import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

/**
 * Shared container for all themed loading animations.
 * Provides centering, overflow control, and prefers-reduced-motion support.
 *
 * Entrance/exit animations are handled by the FadeInOut wrapper in each
 * fallback component (VendorLoadingFallback, AdminLoadingFallback, etc.)
 * using framer-motion's AnimatePresence + motion.div.
 */
export const SceneContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 280,
  maxWidth: 400,
  margin: '0 auto',
  position: 'relative',
  overflow: 'hidden',
  userSelect: 'none',
  '@media (prefers-reduced-motion: reduce)': {
    '& *': {
      animation: 'none !important',
    },
  },
});
